module.exports = "/img/_/_/_/assets/images/creeper/book/common//empty.jpg?7aa964d7792ec9a3ae42f8e7b889b018";